export default __webpack_public_path__ + "static/DEIPage-pattern-large-blue-b7155f3c9a913184e97eca135a80c6af.png";